// NOTE: This is likely not needed once we move to a more up to date version of react-router. There should be built in hooks for something like this.
import { useCallback, useMemo } from 'react';
import { useQuery } from './routing/use-query';
import { useLocation, useHistory } from 'react-router-dom';
import { pageQueryName, pageSizeQueryName } from '../services/pagination-service';

export const usePaging = (defaultPage = 1, defaultPageSize = 250) => {
  const query = useQuery();
  const page = Number.parseInt(query.get(pageQueryName), 10) || defaultPage;
  const pageSize = Number.parseInt(query.get(pageSizeQueryName), 10) || defaultPageSize;

  const location = useLocation();
  const history = useHistory();
  const updatePageInformation = useCallback(
    (newPage, newPageSize) => {
      query.set(pageQueryName, newPage);
      query.set(pageSizeQueryName, newPageSize);
      history.push(`${location.pathname}?${query.toString()}`);
    },
    [query, location, history],
  );
  return useMemo(() => ({ page, pageSize, updatePageInformation }), [page, pageSize, updatePageInformation]);
};
